module.exports = __webpack_public_path__ + "static/media/Housing.968ececc.png";